import { createStyles, Divider, Group, Modal, Stack } from '@mantine/core';
import { Button, Text } from '@repo/foundations';

export interface VersionHistoryRestoreModalProps {
	handleRestoreVersion: () => void;
	isLoading: boolean;
	onClose: () => void;
}

const useStyles = createStyles(() => ({}));

export function VersionHistoryRestoreModal({
	handleRestoreVersion,
	isLoading,
	onClose,
}: VersionHistoryRestoreModalProps) {
	const { theme } = useStyles();

	return (
		<Modal opened onClose={onClose} size="md" title="Restore version">
			<Stack>
				<Text>
					Restoring to this version will overwrite all properties. Do you want
					to continue?
				</Text>
				<Divider mx={`-${theme.spacing.md}`} orientation="horizontal" />
				<Group spacing="sm" position="right">
					<Button variant="default" onClick={onClose}>
						Cancel
					</Button>
					<Button
						variant="primary"
						onClick={handleRestoreVersion}
						loading={isLoading}
					>
						Restore
					</Button>
				</Group>
			</Stack>
		</Modal>
	);
}
